/**
 * Tiny markdown → block model for the guide (Beta-1 plan P8-01: `docs/beta/getting-started-guide.md`
 * is the single source; `/guide` renders it). Supports what the guide uses: `#`/`##`/`###`
 * headings, paragraphs, `- ` lists, `> ` notes, `---`, **bold**, *italic*, `code`, and bare
 * https:// links. Pure module (tested).
 */

export function parseInline(text) {
  const out = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`|https?:\/\/[^\s)]*[^\s).,;:])/g;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push({ t: 'text', v: text.slice(last, m.index) });
    const tok = m[0];
    if (tok.startsWith('**')) out.push({ t: 'bold', v: tok.slice(2, -2) });
    else if (tok.startsWith('`')) out.push({ t: 'code', v: tok.slice(1, -1) });
    else if (tok.startsWith('*')) out.push({ t: 'italic', v: tok.slice(1, -1) });
    else out.push({ t: 'link', v: tok, href: tok });
    last = m.index + tok.length;
  }
  if (last < text.length) out.push({ t: 'text', v: text.slice(last) });
  return out;
}

export function slugify(s) {
  return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export function parseMarkdown(src) {
  const lines = String(src || '').replace(/\r\n/g, '\n').split('\n');
  const blocks = [];
  let para = [];
  let list = null;
  let quote = [];
  const flushPara = () => { if (para.length) { blocks.push({ type: 'p', inline: parseInline(para.join(' ')) }); para = []; } };
  const flushList = () => { if (list) { blocks.push({ type: 'ul', items: list.map(parseInline) }); list = null; } };
  const flushQuote = () => { if (quote.length) { blocks.push({ type: 'quote', inline: parseInline(quote.join(' ')) }); quote = []; } };
  const flushAll = () => { flushPara(); flushList(); flushQuote(); };
  for (const raw of lines) {
    const line = raw.trimEnd();
    const h = /^(#{1,3})\s+(.*)$/.exec(line);
    if (h) { flushAll(); blocks.push({ type: 'h', level: h[1].length, text: h[2].trim(), id: slugify(h[2]), inline: parseInline(h[2].trim()) }); continue; }
    if (/^---+$/.test(line)) { flushAll(); blocks.push({ type: 'hr' }); continue; }
    if (/^- /.test(line)) { flushPara(); flushQuote(); (list = list || []).push(line.slice(2)); continue; }
    if (/^> ?/.test(line)) { flushPara(); flushList(); quote.push(line.replace(/^> ?/, '')); continue; }
    if (!line.trim()) { flushAll(); continue; }
    flushList(); flushQuote(); para.push(line.trim());
  }
  flushAll();
  return blocks;
}

/** Table of contents: level-2 headings with ids. */
export function toc(blocks) {
  return blocks.filter((b) => b.type === 'h' && b.level === 2).map((b) => ({ id: b.id, text: b.text }));
}
